"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = void 0;
const react_1 = __importStar(require("react"));
const Textarea_styles_1 = require("./Textarea.styles");
const useAutoResizeChangeHandler = (onChange) => (event) => {
    var _a, _b;
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
    const textarea = event.target;
    textarea.style.height = "auto";
    const computedStyle = typeof window !== "undefined"
        ? getComputedStyle(textarea)
        : undefined;
    const paddingBlock = parseFloat((_a = computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.paddingTop) !== null && _a !== void 0 ? _a : "0") +
        parseFloat((_b = computedStyle === null || computedStyle === void 0 ? void 0 : computedStyle.paddingBottom) !== null && _b !== void 0 ? _b : "0");
    const minContentHeight = textarea.scrollHeight - paddingBlock;
    if (minContentHeight > textarea.clientHeight - paddingBlock) {
        textarea.style.height = `${minContentHeight}px`;
    }
};
const Textarea = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { isInvalid, autoResize } = _a, props = __rest(_a, ["isInvalid", "autoResize"]);
    const handleOnChange = useAutoResizeChangeHandler(props.onChange);
    const updatedProps = Object.assign(Object.assign({}, props), (autoResize && { onChange: handleOnChange }));
    return (react_1.default.createElement(Textarea_styles_1.StyledTextareaWrapper, { "$isInvalid": isInvalid },
        react_1.default.createElement(Textarea_styles_1.StyledTextarea, Object.assign({ "aria-invalid": isInvalid, ref: forwardedRef }, updatedProps))));
});
exports.Textarea = Textarea;
Textarea.displayName = "Textarea";
//# sourceMappingURL=Textarea.js.map